import {observer} from "mobx-react";
import Accordion from "../../models/Accordion";
import DeleteIcon from '@mui/icons-material/Delete';
import {useNavigate} from "react-router-dom";
import {useStore} from "../../stores/Store";
import React from "react";
import ConfirmationDialog from "../Misc/ConfirmationDialog/ConfirmationDialog";

interface Props {
    accordion: Accordion
}

export default observer(function AccordionDeleteDialog({accordion}: Props){
    const navigate = useNavigate();
    const { AccordionStore, LanguageStore } = useStore();
    const { currentLanguageMessages } = LanguageStore;

    const handleDelete = async () => {
        AccordionStore.delete(accordion.id).then(() => navigate("/Accordions"))
    }


    return (
        <ConfirmationDialog
            confirmationTitle={currentLanguageMessages.AccordionsPage.DeleteAccordion.ConfirmationDialogTitle}
            confirmationText={currentLanguageMessages.AccordionsPage.DeleteAccordion.ConfirmationDialogContent}
            buttonColor={'error'}
            buttonIcon={<DeleteIcon />}
            buttonLabel={currentLanguageMessages.GeneralComponentLabels.deleteButtonLabel}
            confirmCallback={handleDelete}
        />
    )
})